module.exports = __webpack_public_path__ + "static/media/house-3.521c065d.jpeg";